module.exports = __webpack_public_path__ + "static/media/twitter-icon-white.daae1bf5.svg";